/**
 * The markers a ticket type can have (TOADO-413, TOADO-526), in the order the
 * settings pages offer them.
 *
 * One list for every surface. The settings pages pick from it and the renderer
 * (`TICKET_TYPE_GLYPH_DRAWINGS` in render.ts) draws each one, and
 * test/type-glyph.test.ts holds the two equal: a marker cannot be offered without
 * a drawing, nor drawn without being offered.
 *
 * Fixed, not typed: a workspace can call a type anything, but its marker must be
 * one an installed build can draw. A glyph from a newer build than this one
 * draws the marker's own style (TOADO-297), which is why the API accepts any
 * well-formed token and the picker keeps one it does not know.
 *
 * `bug` is drawn by the `bug` style's sprite, not by the glyph switch.
 */
export const TICKET_TYPE_GLYPHS: ReadonlyArray<{ readonly value: string; readonly label: string }> = [
  { value: 'bug', label: 'Bug' },
  { value: 'improvement', label: 'Improvement' },
  { value: 'feature', label: 'Star' },
  { value: 'question', label: 'Question' },
  { value: 'warning', label: 'Warning' },
  { value: 'block', label: 'Blocked' },
  { value: 'bolt', label: 'Lightning' },
  { value: 'wrench', label: 'Wrench' },
  { value: 'code', label: 'Code' },
  { value: 'lock', label: 'Lock' },
  { value: 'eye', label: 'Eye' },
  { value: 'search', label: 'Magnifier' },
  { value: 'chat', label: 'Speech bubble' },
  { value: 'note', label: 'Note' },
  { value: 'pencil', label: 'Pencil' },
  { value: 'check', label: 'Tick' },
  { value: 'flag', label: 'Flag' },
  { value: 'clock', label: 'Clock' },
  { value: 'idea', label: 'Light bulb' },
  { value: 'heart', label: 'Heart' },
  { value: 'user', label: 'Person' },
  { value: 'mobile', label: 'Phone' },
  { value: 'globe', label: 'Globe' },
  { value: 'dot', label: 'Plain dot' },
];

/** A marker's name for people, or the token itself for one this build does not know. */
export function ticketTypeGlyphLabel(glyph: string): string {
  return TICKET_TYPE_GLYPHS.find((option) => option.value === glyph)?.label ?? glyph;
}
